import React from 'react';
import styled from 'styled-components';

const End = (props) =>{
 const {title, intro, submitAnswer} = props
	return (
		<Container color={props.background}>
			<Title>{title}</Title>
			<SubTitle>{intro}</SubTitle>
			<Next onClick={()=>submitAnswer()} id="end" color={props.textColor}>{props.langugage===1?"Envoyer":"Submit"}</Next>
		</Container>

		)
}

export default End


const Title = styled.div`
	font-size: 50px;
  font-weight: bold;
  font-family: 'Barlow', sans-serif;
  margin-bottom:20px;
  color:white;
   line-height:1;
   max-width:654px;

   @media only screen and (min-width:992px){
   font-size: 72px;
   margin-bottom:50px;
  }
`
const SubTitle = styled.div`
	font-size: 18px;
	line-height: 1.6;
  color: white;
  font-family: 'Barlow', sans-serif;
  margin-bottom:20px;
  max-width:654px;

   @media only screen and (min-width:992px){
   font-size: 72px;
   margin-bottom:50px;
   font-size: 24px;
  }
`

const Next = styled.div`
	width: 170px;
  height: 47px;
   border-radius: 5px;
  background-color: white;
  color: ${props=>props.color};
   font-size: 16px;
  font-weight: bold;
  font-family: 'Red Hat Display', sans-serif;
  display:flex;
  align-items:center;
  justify-content:center;
  cursor:pointer;
`

const Container = styled.div`
  position:absolute;
  top:15%;
  padding:20px;
  background:${props=>props.color};

  @media only screen and (min-width:992px){
    left: 25%;
  top: 25%;
  }
`